<template lang="pug">
  .component-driver-subscriptions
    .action-bar
      h2 Subscriptions
    .driver-subscriptions.tabs-inner-content
      base-list(:component="component", :dataLoader="dataLoader", componentType="driver-data")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import BaseList from "../../../pages/backoffice/BaseList";

  export default {
    name: "DriverSubscriptions",
    components: {
      BaseList,
    },
    data() {
      return {
        component: require('components/backoffice/Subscription'),
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.drivers.list(page, resultsPerPage, {id: this.$route.params.id}).subscriptions((data) => {
          data.items_count = data.length
          data.items = data
          callback(data)
        })
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .driver-subscriptions
    margin: 10px
</style>



// WEBPACK FOOTER //
// DriverSubscriptions.vue?71495a1a